/**
 * Kept out of the popover JSX so the chips can import the store without it, and
 * so that file keeps exporting only components — what Fast Refresh needs.
 */
import { create } from "zustand";

export type PopoverTarget =
  | { kind: "node"; nodeId: string }
  | { kind: "cable"; cableId: string };

type PopoverState = {
  open: boolean;
  target: PopoverTarget | null;
  /** Anchor rect at trigger time (in viewport coordinates). */
  anchor: { x: number; y: number; width: number; height: number } | null;
  openPopover(target: PopoverTarget, anchor: DOMRect): void;
  close(): void;
  toggle(target: PopoverTarget, anchor: DOMRect): void;
};

export const useCommentPopover = create<PopoverState>((set, get) => ({
  open: false,
  target: null,
  anchor: null,
  openPopover: (target, anchor) =>
    set({
      open: true,
      target,
      anchor: {
        x: anchor.left,
        y: anchor.top,
        width: anchor.width,
        height: anchor.height,
      },
    }),
  close: () => set({ open: false, target: null, anchor: null }),
  toggle: (target, anchor) => {
    const { open, target: current } = get();
    const sameTarget =
      current &&
      ((current.kind === "node" &&
        target.kind === "node" &&
        current.nodeId === target.nodeId) ||
        (current.kind === "cable" &&
          target.kind === "cable" &&
          current.cableId === target.cableId));
    if (open && sameTarget) {
      get().close();
    } else {
      get().openPopover(target, anchor);
    }
  },
}));
